
import Vue from "vue";
import dayjs from "dayjs";

import Spinner from "@/components/Spinner.vue";

export default Vue.extend({
  name: "Navbar",
  components: { Spinner },
  computed: {
    routeName() {
      return this.$route.name;
    },
    user() {
      return this.$store.getters.user;
    },
    company() {
      return this.$store.getters.company;
    },
    isSidebar: {
      get() {
        return this.$store.state.app.isSidebar;
      },
    },
    visible: {
      get() {
        return this.$store.state.app.visibleSidebar;
      },
      set(value: boolean) {
        this.$store.dispatch("setApp", {
          ...this.$store.state.app,
          visibleSidebar: value,
        });
      },
    },
  },
  data() {
    return { interval: null, timer: null, userDefault: require("@/assets/images/default-user.png") };
  },
  created() {
    const routeNameHideList = [
      "MonitoringPage",
      "CompaniesPage",
      "CompanyMemberPage",
      "AdminPage",
      "ManageMemberPage",
      "OperationMonitorPage",
      "AskCenAiPage",
      "RvsCalculationPage",
    ];
    const routeNameCloseList = ["ViewModelPage"];

    const routeHideData = routeNameHideList.find((name: string) => this.routeName === name);
    const routeCloseData = routeNameCloseList.find((name: string) => this.routeName === name);

    this.$store.dispatch("setApp", {
      isSidebar: routeCloseData || routeHideData ? false : true,
      visibleSidebar: routeHideData ? false : true,
    });

    (this as any).interval = setInterval(() => {
      (this as any).timer = dayjs(new Date()).format("ddd, DD MMM YYYY HH:mm");
    }, 1000);
  },
  methods: {
    handleEditProfile() {
      this.$store.dispatch("openEditUserModal", true);
    },
    handleMonitoring() {
      this.$router.push({ name: "MonitoringPage" });
    },
    handleOperationMonitor() {
      this.$router.push({ name: "OperationMonitorPage" });
    },
    handleAskCenAi() {
      this.$router.push({ name: "AskCenAiPage" });
    },
    handleSettingCompanies() {
      this.$router.push({ name: "CompaniesPage" });
    },
    handleSettingAdmin() {
      this.$router.push({ name: "AdminPage" });
    },
    handleRvsCalculation() {
      this.$router.push({ name: "RvsCalculationPage" });
    },
    handleLogout() {
      (this as any).$dep.authUseCase.logout();
    },
    handleGotoCaseManagement() {
      window.open("https://case.repconexis.com", "_blank");
    },
    handleManageMembers() {
      this.$router.push({ name: "ManageMemberPage" });
    },
    handleBacktoOverall() {
      const id = this.company?.id;
      if (id) this.$router.push(`/company/${id}`);
    },
    imagePathError(event: any) {
      event.target.src = this.userDefault;
    },
  },
  watch: {
    routeName() {
      // กำหนดเงื่อนไขเพื่อให้แสดงปุ่มเปิดปิด sidebar ในหน้าที่ต้องการ
      const routeNameHideList = [
        "MonitoringPage",
        "CompaniesPage",
        "CompanyMemberPage",
        "AdminPage",
        "ManageMemberPage",
        "OperationMonitorPage",
        "AskCenAiPage",
        "RvsCalculationPage",
      ];
      const routeNameCloseList = ["ViewModelPage"];

      const routeHideData = routeNameHideList.find((name: string) => this.routeName === name);
      const routeCloseData = routeNameCloseList.find((name: string) => this.routeName === name);

      this.$store.dispatch("setApp", {
        isSidebar: routeCloseData || routeHideData ? false : true,
        visibleSidebar: routeHideData ? false : true,
      });
    },
  },
  beforeDestroy() {
    clearInterval((this as any).interval);
  },
});
